import * as React from 'react';
import Contentcard from './Contentcard';
import Grid from '@mui/material/Unstable_Grid2';
import {Amplify} from 'aws-amplify';
import { generateClient } from 'aws-amplify/api';
import NavBar from './NavBar';


export default function CrApp() {
    const [movies, setMovies] = React.useState([]);

    React.useEffect(() => {
        fetchMovies();
    }, []);

    const fetchMovies = async () => {
        try {
            const Secret_Val = process.env.REACT_APP_API_KEY;
            const API_Endpoint = process.env.REACT_APP_API_ENDPOINT;

            Amplify.configure({
            API: {
                GraphQL: {
                endpoint: API_Endpoint,
                region: 'us-east-2',
                defaultAuthMode: 'apiKey',
                apiKey: Secret_Val
                }
            }
            });
            const client = generateClient();

            const movieOnlyQuery = `
                query {
                    listMovies {
                        items {
                            id
                            image_url
                            name
                            sortKey
                        }
                    }
                }
            `
            
            const movieData = await client.graphql({ query: movieOnlyQuery});
            const movieList = movieData.data.listMovies.items;

            setMovies(movieList);
            
        } catch (error) {
            console.log('error on fetching movies', error)
        }
    }

    return (
        <>
            <NavBar />
            <Grid container spacing={2} sx={{paddingLeft:'2%', paddingRight:'2%'}}>
                    {movies.map((movie) => (
                    <Contentcard 
                    image={movie.image_url}
                    videoURL={movie.name}
                    />
                ))}
            </Grid>
        </>
    );
}
